module.exports = __webpack_public_path__ + "static/stopkalogo-533374-680ec2ff60394becc2aa6c2fdc567aa3.webp";